import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { SidebarItemText } from './SidebarItemText';
import { BaseSidebarItemData } from './types';
import { BaseBadge } from '@/lib';

type BaseSidebarItemProps = BaseSidebarItemData & {
  classNames?: {
    icon?: string;
    text?: string;
  };
  isNew?: boolean;
};

export const BaseSidebarItem: FC<BaseSidebarItemProps> = ({ title, classNames, isNew, ...rest }) => {
  const { t } = useTranslation('ALL');

  return (
    <>
      <rest.icon
        className={twMerge('size-5 shrink-0 text-quaternary-400 motion-safe:[transition:color_300ms_ease] motion-reduce:transition-none', classNames?.icon)}
      />
      <div className='w-full flex items-center justify-between'>
        <SidebarItemText text={t(title as any)} className={classNames?.text} />
        {isNew && <BaseBadge className='bg-brand-400 text-white-white'>New</BaseBadge>}
      </div>
    </>
  );
};
